
import { defineComponent, computed } from 'vue';
import ESARSite from '@/models/ESARSite';

import AgriculturalIcon from '@/assets/img/agricultural-icon.svg';
import CommercialIcon from '@/assets/img/commercial-icon.svg';
import IndustrialIcon from '@/assets/img/industrial-icon.svg';
import NaturalIcon from '@/assets/img/natural-icon.svg';
import ResidentialIcon from '@/assets/img/residential-icon.svg';
import ResidentialParklandIcon from '@/assets/img/residential-parkland-icon.svg';
import SensetiveLandNoneIcon from '@/assets/img/sensetive-land-none.svg';

import Pill from '../Pill/Pill.vue';

export default defineComponent({
    name: 'Details',
    components: {
        Pill
    },
    props: {
        siteDetails: ESARSite
    },
    setup(props) {
        const apiKey = `key=${process.env.VUE_APP_GOOGLE_MAPS_API_KEY}`;

        const siteStatusPillColor = computed(() => {
            const status = props.siteDetails?.currentSiteStatus || '';
            if (['OPN', 'CER'].includes(status)) {
                return 'blue';
            }
            if (['PND', 'SUS'].includes(status)) {
                return 'red';
            }
            return 'grey';
        });

        const landUseCriteria = computed(() => {
            const images = [];
            if (props.siteDetails?.isAgricultural.toLowerCase().includes('y')) {
                images.push([AgriculturalIcon, 'Agricultural']);
            }
            if (props.siteDetails?.isCommercial.toLowerCase().includes('y')) {
                images.push([CommercialIcon, 'Commercial']);
            }
            if (props.siteDetails?.isIndustrial.toLowerCase().includes('y')) {
                images.push([IndustrialIcon, 'Industrial']);
            }
            if (props.siteDetails?.isNatural.toLowerCase().includes('y')) {
                images.push([NaturalIcon, 'Natural']);
            }
            if (props.siteDetails?.isResidential.toLowerCase().includes('y')) {
                images.push([ResidentialIcon, 'Residential']);
            }

            if (images.length === 0) {
                images.push([SensetiveLandNoneIcon, 'None']);
            }

            return images;
        });

        const mostSensitiveLandUseWithin30m = computed(() => {
            let res = [SensetiveLandNoneIcon, 'None'];

            if (props.siteDetails?.isMoreSensetiveLandWithin30m.toLowerCase() !== 'yes') {
                return res;
            }

            switch (props.siteDetails?.mostSensetiveLandUse.toLowerCase()) {
            default: break;
            case 'res/park':
                res = [ResidentialParklandIcon, 'Residential/Park'];
                break;
            }

            return res;
        });

        const [mostSensitiveLandUseWithin30mImage, mostSensitiveLandUseWithin30mLabel] = mostSensitiveLandUseWithin30m.value;

        const allSubstancesRemediatedToCriteria = computed(() => {
            const val = props.siteDetails?.allSubstancesRemediatedToCriteria.toLowerCase();
            if (val === 'y') {
                return 'yes';
            }
            if (val === 'n') {
                return 'no';
            }
            return 'n/a';
        });
        const allSubstancesRemediatedToCriteriaColor = computed(() => {
            if (allSubstancesRemediatedToCriteria.value === 'yes') {
                return 'blue';
            }
            if (allSubstancesRemediatedToCriteria.value === 'no') {
                return 'red';
            }
            return 'grey';
        });

        const humanHealthConcernsOrExceedancesColor = computed(() => {
            const val = props.siteDetails?.humanHealthConcernsOrExceedances.toLowerCase() || 'na';
            if (['n', 'no'].includes(val)) {
                return 'blue';
            }
            if (['na', 'n/a'].includes(val)) {
                return 'grey';
            }
            return 'red';
        });

        const googleMapSrc = computed(() => {
            const markers = props.siteDetails?.coordinates.map((i) => `markers=color:red|size:mid|${i?.latitude},${i?.longitude}`) || [];

            return [
                `https://maps.googleapis.com/maps/api/staticmap?${apiKey}`,
                'size=400x350',
                'maptype=satellite',
                ...markers
            ].join('&');
        });

        return {
            googleMapSrc,
            allSubstancesRemediatedToCriteria,
            allSubstancesRemediatedToCriteriaColor,
            humanHealthConcernsOrExceedancesColor,
            siteStatusPillColor,
            landUseCriteria,
            mostSensitiveLandUseWithin30mImage,
            mostSensitiveLandUseWithin30mLabel
        };
    }
});
